module.exports = __webpack_public_path__ + "static/media/scan-product.bc3099d3.png";